module.exports = __webpack_public_path__ + "8f8cc9a1e5a57ab3122d06cc82307669.png";